export const beneficiariesTabs = [
  { label: 'Overview' },
  // { label: 'Beneficiaries Tracking' },
  { label: 'Pregnancy Services' },
  { label: 'Family Planning' },
  { label: 'Child Tracking' },
  {
    label: 'MCH Card',
    tooltipMsg: 'MCH card is only available for Abha verified beneficiaries',
  },
  // { label: 'Services' },
  { label: 'Life Calendar' },
  { 
    label: 'HRP Tracking',
    tooltipMsg: 'HRP Tracking is only available for pregnancy registered beneficiaries',
   },
   { label: 'Referral',
      tooltipMsg: 'Referral Module is only available for Active users',
    },

  // { label: 'Beneficiary Referral' },
  { label: 'Poshan' },
  {label: 'JSSK'}
];
export const childTabs = [
  { label: 'Overview' },
  { label: 'Services' },
  { label: 'Immunization' },
  { label: 'Referral',
    tooltipMsg: 'Referral Module is only available for Active users',
  },
  {
    label: 'MCH Card',
    tooltipMsg: 'MCH Card is only available for Abha verified beneficiaries',
  },
  { 
    label: 'Poshan',
    tooltipMsg: 'Poshan is only available for Abha verified beneficiaries'
   }
];

export const referralTabPermission = ['ANM', 'Medical Officer Incharge - PHC/CHC'];

export const DATE_TIME_FORMATS = {
  TIME: 'HH:mm',
  DATE: 'YYYY-MM-DD',
  DATE_TIME: 'YYYY-MM-DD HH:mm:ss',
};

export const REGEX_PATTERNS = {
  DATE_DD_MM_YYYY: /^\d{2}-\d{2}-\d{4}$/,
};

export const serviceStatus = {
  ongoing: 'Ongoing',
  completed : 'Completed'
}

export const pregnancy_details_constant = {
  pncChild:'pnc_child',
  pncMother: 'pnc_mother',
  hbyc:'hbyc',
  newBorn:'new_born',
  sickChildCare:'sick_child_care',
  anc:'anc',
}

export const color_codes = {
  red : 'Red',
  yellow : 'Yellow',
  green : 'Green',
  male : 'Male'
}

export const buttonNames = {
  yes: 'Yes',
  no: 'No',
  addPregnancy:'Add Pregnancy',
  new_session: 'Create new session',
  search_name: 'Search by event name',
  cancel: 'Cancel',
  confirm: 'Confirm Session',
  duplicate: 'Replicate Session',
  edit: 'Edit Session',
  backToImmunizationTable:"Back to Immunization Table",
  update: 'Update Session',
  createDuplicate: 'Save Replicate Session',
  delete:'Delete',
  continueWithAbha: 'Continue with ABHA',
  continueWithAadhaar: 'Continue with Aadhaar',
  changeProfilePicture: 'Change Profile Picture',
  addProfilePicture: "+ Add Profile Picture",
  coverageArea: 'Create Coverage Area',
  editDetails:'Edit Details',
  submit: 'Submit',
  registerAChild:'+ Register a Child',
  addServicesButton: "Add Services",
  closePregnancyButton: "Close Pregnancy",
  HRPCondition: "Add HRP Condition",
  addReferralButton: "Add Referral",
  create:"Create",
  saveSubmit: 'Save & Submit',
  reportAEFI:'+ Report AEFI',
  viewReportedComplication:'View Reported Complications',
  verify:"Verify",
  linkAbha:"Link / Create ABHA",
  geoFilters:"Geo Filters",
  clear:"Clear",
  approve:"Approve",
  editApprove:'Edit / Approve',
  reject:'Reject',
  apply:"Apply",
  back:"Back",
  discard:"Discard",
  next:"Next",
  viewDueList: "View due list",
  startVhnd: "Start Event",
  goToSession: "Go to session",
  reset: "Reset",
  ADD_KYC: '+ Add Re-KYC',
  SKIP_KYC: 'Skip-KYC',
  CONTINUE: 'Continue',
  reSubmit: 'Edit and Re-submit',
  reAuth: 'Re-Authenticate'
};

export const benfTabs = {
  overview:'Overview',
  pregnancyServices: 'Pregnancy Services',
  familyPlanning:'Family Planning',
  childTracking:'Child Tracking',
  mcpCard:'MCH Card',
  hrpTracking:'HRP Tracking',
  referral:'Referral',
  SERVICES: 'Services',
  IMMUNIZATION: 'Immunization',
  FACILITY_REFERRAL:'Facility Referral',
  LIFE_CALENDAR: 'Life Calendar',
  POSHAN: 'Poshan',
  JSSK:'JSSK'
};

export const userDesignationConstant = {
  h_a_dh_sdh: 'Hospital Adminstrator - DH and SDH',
  h_a_other_central_government_hospitals: 'Hospital Administrator - Other Central government hospitals',
  medical_director: 'Medical Director',
  medical_suprintendent: 'Medical Supritendent',
};

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const quarterly = [
  'Q1 - Apr, May and Jun',
  'Q2 - Jul, Aug and Sep',
  'Q3 - Oct, Nov and Dec',
  'Q4 - Jan, Feb and Mar',
];

export const graphTypes = {
  donutChart: 'DonutChart',
  barChart: 'BarChart',
  pieChart: 'PieChart',
  verticalChart: 'VerticalChart',
  stackedBarChart: 'StackedBarChart',
  treeMap: 'TreeMap',
  gaugeChart: 'GaugeChart',
  pieInPieChart: 'PieInPieChart',
}

export const HRP_ERROR_MESSAGES = {
  HRP_NOT_APPLICABLE: (hrpName:any) => `${hrpName} cannot be selected for the first pregnancy.`,
  HRP_ALREADY_EXISTS: (hrpName:any) => `${hrpName} cannot be added once again, as this is already added.`,
}

export const additionalColumnsFormoduleGrid = {
  pages: {
    user_management: "User Management",
    health_facility: "Health Facility"
  },
  columnsBefor: {
    facility_type: 'facility_type',
    admin_body: 'admin_body'
  },
  nationalLevel: [
    {
      name: 'State',
      key: 'state_name',
      sortable: true,
      filterRequired: true,
      filterDefault: true,
      width: 180,
    },
    {
      name: 'District',
      key: 'dist_name',
      sortable: true,
      filterRequired: true,
      filterDefault: true,
      width: 180,
    }
  ],
  stateLevel: [
    {
      name: 'District',
      key: 'dist_name',
      sortable: true,
      filterRequired: true,
      filterDefault: true,
      width: 180,
    },
    {
      name: 'Sub District',
      key: 'sub_dist_name',
      sortable: true,
      filterRequired: true,
      filterDefault: true,
      width: 180,
    }
  ],
  districtLevel: [
    {
      name: 'Sub District',
      key: 'sub_dist_name',
      sortable: true,
      filterRequired: true,
      filterDefault: true,
      width: 180,
    },
    {
      name: 'Block',
      key: 'block_name',
      sortable: true,
      filterRequired: true,
      filterDefault: true,
      width: 180,
    },
    {
      name: 'Health Block',
      key: 'health_block_name',
      sortable: true,
      filterRequired: true,
      filterDefault: true,
      width: 180,
    },
    {
      name: 'Sub Division',
      key: 'sub_division_name',
      sortable: true,
      filterRequired: true,
      filterDefault: true,
      width: 180,
    }
  ],
  subDistrictLevel: [
    {
      name: 'Rural/Urban',
      key: 'urban_or_rural',
      sortable: true,
      filterRequired: true,
      filterDefault: true,
      width: 180,
    },
    {
      name: 'Ownership',
      key: 'ownership',
      sortable: true,
      filterRequired: true,
      filterDefault: true,
      width: 180,
    }
  ]
};

export const userManagementColumnHeader: any [] = [
  {
    name: 'First Name',
    key: 'first_name',
    sortable: true,
    filterRequired: true,
    filterDefault: true,
    width:180,
  },
  {
    name: 'Last Name',
    key: 'last_name',
    sortable: true,
    filterRequired: true,
    filterDefault: true,
    width:180,
  },
  {
    name: 'Mobile Number (User ID)',
    key: 'mob',
    sortable: true,
    filterRequired: true,
    filterDefault: true,
    width:180,
  },
  
  {
    name: 'Designation',
    key: 'user_designation_name',
    sortable: true,
    filterRequired: true,
    filterDefault: true,
    width:180,
  },
  {
    name: 'User Type',
    key: 'usertype_name',
    sortable: true,
    filterRequired: true,
    filterDefault: false,
    width:180,
  },
  {
    name: 'User Status',
    key: 'user_status',
    sortable: true,
    filterRequired: true,
    filterDefault: false,
    width:180,
  },
  {
    name: 'Facility Type',
    key: 'facility_type',
    sortable: true,
    filterRequired: true,
    filterDefault: false,
    width:180,
  },
  {
    name: 'Facility Name',
    key: 'facility_name',
    sortable: true,
    filterRequired: true,
    filterDefault: false,
    width:180,
  },
  {
    name: 'ID',
    key: 'hpr_abha_id',
    sortable: true,
    filterRequired: true,
    filterDefault: false,
    width:180,
  },
  {
    name: 'User Role',
    key: 'roles',
    sortable: true,
    filterRequired: true,
    filterDefault: true,
    width:180,
  },
  {
    name: 'Action',
    key: 'Action',
    sortable: false,
    filterRequired: false,
    filterDefault: false,
    width:180,
  },
];

export const facilityManagementColumnHeader: any [] = [
  {
    name: 'Facility name',
    key: 'facility_name',
    sortable: true,
    filterRequired: true,
    filterDefault: true,
    width: 180,
  },
  {
    name: 'HFR ID',
    key: 'hfr_id',
    sortable: true,
    filterRequired: true,
    filterDefault: true,
    width: 180,
  },
  {
    name: 'Facility type',
    key: 'facility_type',
    sortable: true,
    filterRequired: true,
    filterDefault: true,
    width: 180,
  },
  {
    name: 'Status',
    key: 'stauts',
    sortable: true,
    filterRequired: true,
    filterDefault: true,
    width: 180,
  },
  {
    name: 'Administrative Body',
    key: 'admin_body',
    sortable: true,
    filterRequired: true,
    filterDefault: true,
    width: 180,
  },
  {
    name: 'Action',
    key: 'Action',
    sortable: false,
    filterRequired: false,
    filterDefault: false,
    width: 180,
  },
];

export const logedInUserLevelType = {
  NationalLevelUser: "NationalLevelUser",
  StateLevelUser: "StateLevelUser",
  DistrictLevelUser: "DistrictLevelUser",
  SubDistrictLevelUser: "SubDistrictLevelUser"
};

export const smsNotificationConstants = {
 benefTemplateCode: 'benf_benf_reg',
 abhaTemplateCode: 'benf_abha_validation',
 childTemplateCode: 'benf_child_reg',
 smsRequestTypeCode: 'new_sms'

};

export const otpCooldownTime = 30; // in seconds
export const otpCooldownMessage = `You can request for new OTP after ${otpCooldownTime} seconds.`;